import React, {useContext} from 'react';
import styled from 'styled-components';
import {CalendarIntakeBookContext} from '../contexts/CalendarIntakeBookProvider';
import {MonthlyIntakeBookProvider} from '../contexts/MonthlyIntakeBookProvider';
import CalendarIntakeBook from '../containers/CalendarIntakeBook';
import MonthlyIntakeBookDetailContainer from '../containers/MonthlyIntakeBookDetailContainer';
import Spinner from '../../components/UI/Spinner/Spinner';
import Model from '../../components/UI/Modal/Model';
import IdleTimerContainer from '../../containers/IdleTimer/IdleTimerContainer';
import CustomModal from '../../components/UI/Modal/CustomModal';
import {getMonthAndYearOnlyByDate} from '../../common/utility/utility'

function MonthlyIntakeBookContainer(props) {

    const { intakeBookStartDate, minDate, maxDate, idleTimeoutLimit, sessionTimeoutLimit, isLoading, showModel,
            errorMessage, isError, modelHeaderTitle, showInstructions, resetSubmittedAndErrorFlags,
            handleConfirmationYesClick ,isSuccessfullySaved ,isFileUploadedSuccessfully,unblockFromDate,selectedContractCodeValue, changeReqNumber, requestStatus} = useContext(CalendarIntakeBookContext);  
    const Separator = styled.div`
    clear: both;
    position: relative;
    margin: .01rem 0;
    background-color: #ddd;
    height: 2px;
    `;

    return (
        <>
            <div className="sidebar-bottomcontent-container-col">
                <div style={{height:"49.8vh"}}><></></div>     
                    {intakeBookStartDate && minDate && maxDate &&<div>
                        <Separator />
                        <CalendarIntakeBook  />
                    </div>}
            </div>
            <div className="sidebar-bottomcontent-container-next-col">
                    <div className="main-contents">
                        <div className="main-content"> 
                            <MonthlyIntakeBookProvider  BusinessPartnerCode={props.BusinessPartnerCode} 
                                                        isLogout={props.isLogout}   
                                                        onLogoutClick={props.onLogoutClick}
                                                        clearSessionData={props.clearSessionData}
                                                        UserId={props.UserId}>
                                <MonthlyIntakeBookDetailContainer BusinessPartnerCode={props.BusinessPartnerCode} 
                                isLogout={props.isLogout}   
                                onLogoutClick={props.onLogoutClick}
                                clearSessionData={props.clearSessionData}/>
                            </MonthlyIntakeBookProvider>
                        </div>
                    </div>
            </div> 
            { showModel && (!requestStatus || requestStatus <=1) && 
                <Model showModel={showModel}
                    onHideHandler={resetSubmittedAndErrorFlags}
                    showHeader={showModel}
                    headerTitle={modelHeaderTitle}
                    showError={isError}
                    errorMessage={errorMessage}
                    isMonthlyIntakeBook={true}
                    isBusinessPartner={true}
                    showInstructions={showInstructions}
                    handleConfirmationYesClick={handleConfirmationYesClick}
                    showSuccess={isSuccessfullySaved  || isFileUploadedSuccessfully} 
                    successMessage= {errorMessage}
                    additionInfo={changeReqNumber}
                />
            } 
            { showModel && (requestStatus && requestStatus >1) && 
                                                <CustomModal showModel={showModel}
                                                    onHideHandler={resetSubmittedAndErrorFlags}
                                                    Status={requestStatus}
                                                    contractCode={selectedContractCodeValue}
                                                    BusinessPartnerCode={props.BusinessPartnerCode}
                                                    RevenueDate={requestStatus > 3 ? unblockFromDate : (getMonthAndYearOnlyByDate(intakeBookStartDate))}
                                                    ErrorMessage={errorMessage}
                                                    isDailyReceiptJournal={true}
                                                />
            }        
            {isLoading ? <Spinner isLogin = {true}/> : undefined}                 
            {sessionTimeoutLimit && idleTimeoutLimit && <IdleTimerContainer idleTimeoutLimit={1000 * idleTimeoutLimit}
                                    sessionTimeoutLimit={1000 * sessionTimeoutLimit}
                                    logout={props.onLogoutClick} />}
        </>
    );
}

export default MonthlyIntakeBookContainer;